import ConditionedComponent from './ConditionedComponent.js';
import React, { Component } from 'react';

class ConditionedCheckmark extends Component {
    render() {
        let className ='small_checkmark ';
        if (this.props.className) {
            className += this.props.className;
        }
        return (
            <ConditionedComponent condition={this.props.condition}>
              <span className={className}>
                <div className="small_checkmark_stem"></div>
                <div className="small_checkmark_kick"></div>
              </span>
            </ConditionedComponent>
        );
    }
}

export default ConditionedCheckmark;
